// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "ad484dc42bf2f9e72632bc411d67c25f897acf6d/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};